import { ref } from 'vue'

// Controls whether the premises-address (cross-field) validation error is shown. It's set on a Next /
// submit attempt and cleared as soon as the user re-engages the address field, so the error surfaces
// only after a submit — not while the user is typing / searching / picking — and clears again on the
// next interaction or on capture. A module-level ref is enough: one address field per form.
export const showAddressError = ref(false)

export const markAddressSubmitted = () => { showAddressError.value = true }
export const markAddressTouched = () => { showAddressError.value = false }
